import { createAction } from '@reduxjs/toolkit';
export var executeCommands = createAction('command/executeCommands');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/CommandState/CommandState.actions.js
// module id = 887
// module chunks = 11